export default {
  methods: {
    formatterType (r, b, c) {
      switch (c) {
        case 1: return '单选题'
        case 2: return '多选题'
        case 3: return '判断题'
        case 4: return '排序题'
        case 5: return '填空题'
      }
    },
    formatterLevel (r, b, c) {
      switch (c) {
        case 0: return '容易'
        case 1: return '中等'
        case 2: return '困难'
      }
    },
    formatterSparkLevel (c) {
      switch (c) {
        case 'primary_question': return '初级题目'
        case 'interme_question': return '中级题目'
        case 'interme_question': return '高级题目'
      }
    },
    formatcaseCharacter (c) {
      switch (c) {
        case 1:
          return '常见病例典型特征';
        case 2:
          return '常见病例不典型特征';
        case 3:
          return '少见病例典型特征';
        case 4:
          return '少见病例不典型特征';
      }
    },
    formattervedioType (r, b, c) {
      switch (c) {
        case 0: return '理论知识'
        case 1: return '读片知识'
      }
    }
  }
}


// WEBPACK FOOTER //
// ./src/mixin/formatter.js